export default function Divider({ light = false, className = "" }) {
  const line = light ? "bg-oro/40" : "bg-bordeaux/40";
  const ring = light ? "border-oro" : "border-bordeaux";
  const dot = light ? "bg-oro" : "bg-bordeaux";
  return (
    <div data-testid="brand-divider" className={`flex items-center justify-center gap-3 ${className}`}>
      <div className={`h-px w-16 sm:w-24 ${line}`} />
      <div className={`h-4 w-4 rounded-full border-2 ${ring} flex items-center justify-center`}>
        <div className={`h-1.5 w-1.5 rounded-full ${dot}`} />
      </div>
      <div className={`h-px w-16 sm:w-24 ${line}`} />
    </div>
  );
}
